const es = {
  nav: {
    home: 'INICIO',
    about: 'SOBRE MÍ',
    experience: 'EXPERIENCIA',
    work: 'PROYECTOS',
  },
  hero: {
    greeting: 'Hola, soy',
    role: 'Desarrollador Fullstack 💻',
    description: 'Construyendo aplicaciones web, móviles y sistemas backend desde 2021.',
    cta: 'VER MI TRABAJO',
    github: 'GITHUB →',
    techStack: 'Stack tecnológico',
  },
  about: {
    sectionLabel: 'Sobre mí',
    title: 'Sobre mí',
    headline1: 'Convierto ideas en',
    headline2: 'productos reales.',
    bio: 'Desde 2021 he trabajado en el stack completo — desarrollando plataformas web, manteniendo sistemas en producción, construyendo apps móviles y conectando servicios a través de APIs y microservicios. Mis herramientas principales son React, Node.js y SQL, con experiencia en la nube con AWS. He entregado proyectos de principio a fin para clientes reales, siempre buscando la solución correcta y no la más rápida. Me gustan los retos y siempre estoy aprendiendo algo nuevo.',
    stats: [
      { value: '4+',   label: 'Años de experiencia'   },
      { value: '10+',  label: 'Proyectos entregados'  },
      { value: '100%', label: 'Autodidacto'            },
    ],
    cvButton: 'Ver mi CV',
    techLabel: 'Tecnologías',
    techTitle: 'Mi stack tecnológico',
    categories: {
      frontend: 'Frontend',
      backend: 'Backend',
      mobile: 'Móvil',
      tools: 'Herramientas',
    },
    cvModal: {
      title: 'Currículum Vitae',
      download: 'Descargar',
      loading: 'Cargando PDF…',
      error: 'No se pudo cargar la vista previa del PDF',
      downloadInstead: 'Descargar CV',
      prev: 'Anterior',
      next: 'Siguiente',
      of: 'de',
    },
  },
  work: {
    sectionLabel: 'Trayectoria',
    title: 'Experiencia',
    responsibilities: 'Responsabilidades',
    techStack: 'Stack tecnológico',
    expand: 'Expandir',
    collapse: 'Contraer',
    experience: [
      {
        date: '2022 – Presente',
        badge: 'Actual',
        title: 'Desarrollador Fullstack',
        company: 'IDC Online',
        companyUrl: 'https://www.idconline.mx',
        description:
          'Desarrollo web, mantenimiento de APIs, plataformas web, sistemas backend y desarrollo de apps móviles en React Native. Publicada en ambas tiendas. Integraciones con ERP y CRM.',
        activities: [
          'Desarrollo y publicación de la app móvil en App Store y Google Play.',
          'Mantenimiento de APIs existentes y creación de nuevos servicios.',
          'Mantenimiento y desarrollo en AWS.',
          'Gestión de bases de datos SQL.',
          'Desarrollo web y despliegue.',
          'Uso de datos y desarrollo en Odoo.',
          'Creación y uso de servicios de datos y backend.',
          'Pruebas y depuración de código.',
        ],
        tags: ['REACT_NATIVE', 'NODE', 'AWS', 'SQL', 'ODOO', 'TYPESCRIPT', 'JAVASCRIPT', 'SQL', 'EXPO'],
      },
      {
        date: '2021',
        badge: null,
        title: 'Desarrollador Frontend',
        company: '4Plus1 Creative',
        companyUrl: '#',
        description:
          'Páginas web y sistemas con JavaScript, integraciones con APIs y mantenimiento de backend.',
        activities: [
          'Diseño e implementación de sitios web.',
          'Mantenimiento de sistemas backend.',
          'Gestión de bases de datos.',
        ],
        tags: ['JAVASCRIPT', 'HTML', 'CSS', 'NODE', 'GOLANG'],
      },
      {
        date: '2020',
        badge: 'Primer trabajo',
        title: 'Desarrollador Móvil',
        company: 'Marzhal Hackers',
        companyUrl: '#',
        description:
          'Desarrollé una app móvil en React Native y una plataforma web como proyecto de prácticas.',
        activities: [
          'Desarrollo de la aplicación móvil en React Native.',
          'Creación de una plataforma web.',
          'Pruebas y depuración de código.',
        ],
        tags: ['REACT_NATIVE', 'JAVASCRIPT'],
      },
    ],
  },
  projects: {
    sectionLabel: 'ALGUNOS PROYECTOS',
    subtitle: 'Una selección de proyectos que he desarrollado. Haz clic en cualquier tarjeta para ver más.',
    viewProject: 'Ver proyecto',
    clickToView: 'Clic para ver →',
    availableOn: 'Disponible en',
    stack: 'Stack',
    clickToExpand: 'Clic para ampliar',
    close: 'Cerrar',
    status: {
      inProgress: 'En desarrollo',
      published:  'Publicada',
      completed:  'Completado',
    },
    items: [
      {
        title: 'App de Gestión de Tareas',
        shortDesc: 'App multiplataforma con sincronización en tiempo real.',
        description:
          'Aplicación de tareas multiplataforma con sincronización en tiempo real entre la app móvil y el panel web. Construida desde cero con una API REST en Node.js y desplegada en AWS. Incluye autenticación, categorías de tareas, recordatorios y soporte sin conexión.',
        statusKey: 'inProgress',
      },
      {
        title: 'App Móvil IDC',
        shortDesc: 'App móvil para clientes de IDC Online.',
        description:
          'Primer proyecto profesional — una aplicación móvil completa para los clientes de IDC Online. Desarrollada desde cero con React Native y Expo. Publicada en App Store de Apple y Google Play. Incluye contenido en tiempo real, notificaciones push y un sistema de diseño limpio.',
        statusKey: 'published',
      },
      {
        title: 'Sistema de Gestión de Préstamos',
        shortDesc: 'Sistema completamente funcional y automatizado en todas sus tareas.',
        description:
          'Sistema completamente automatizado para gestionar y administrar préstamos de clientes, controlado mediante una API para procesar pagos, penalizaciones y otras transacciones. Responsive en todos los dispositivos, con gestión de usuarios y roles. Desarrollado para un cliente privado.',
        statusKey: 'completed',
      },
    ],
  },
  footer: {
    about: 'Sobre mí',
    privacy: 'Política de privacidad',
    contact: 'Contacto',
    madeBy: 'Hecho con 💗 por mí.',
  },
}

export default es
